// Replaces `@edgespark/client`'s auth piece (createEdgeSpark) with better-auth's
// own React client, talking directly to our Worker instead of YouWare's
// hosted youbase.cloud endpoint.
import { createAuthClient } from "better-auth/react";
import { adminClient, twoFactorClient } from "better-auth/client/plugins";

// Same value as VITE_BACKEND_URL used elsewhere in this app (see src/lib/client.ts) —
// set at build time via .env.production.local, same pattern as the website migration.
const BACKEND_URL = import.meta.env.VITE_BACKEND_URL as string;

export const authClient = createAuthClient({
  baseURL: BACKEND_URL,
  basePath: "/api/auth",
  // twoFactorClient() is what exposes `authClient.twoFactor.*` (enable,
  // verifyTotp, verifyBackupCode, getTotpUri, generateBackupCodes, ...) —
  // the counterpart to the backend's twoFactor() plugin in auth-config.ts.
  // No `onTwoFactorRedirect`/`twoFactorPage` option here on purpose: LoginForm
  // itself inspects `signIn.email`'s returned `data?.twoFactorRedirect` and
  // switches to a code-entry step in place, rather than a full navigation.
  plugins: [adminClient(), twoFactorClient()],
  fetchOptions: {
    // Required so the session cookie set by the Worker (a different origin
    // than the frontend, unless you put both behind the same domain) is
    // actually sent back on every request.
    credentials: "include",
  },
});

export const { useSession, signIn, signOut } = authClient;
